// ==============================|| DRAWER CONTENT - NAVIGATION CARD ||============================== //

const NavCard = () => <></>;

export default NavCard;
